import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import ListState from './list-state';

interface ListProps<T> {
  items: T[];
  isLoading: boolean;
  hasAnyItems: boolean;
  renderItem: (item: T) => ReactNode;
  getItemKey: (item: T) => string | number;
  emptyMessage?: string;
}

const List = <T,>({
  items,
  isLoading,
  hasAnyItems,
  renderItem,
  getItemKey,
  emptyMessage = 'No items found.',
}: ListProps<T>) => {
  return (
    <ListState isLoading={isLoading} hasAnyItems={hasAnyItems} emptyMessage={emptyMessage}>
      {items.length === 0 ? (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            {emptyMessage}
          </Typography>
        </Box>
      ) : (
        <Stack>
          {items.map((item) => (
            <Box key={getItemKey(item)}>{renderItem(item)}</Box>
          ))}
        </Stack>
      )}
    </ListState>
  );
};

export default List;
